var exports = {
  "Nr": "VoiceActivityCard.module__card___bEwyRE",
  "wu": "VoiceActivityCard.module__headerContextGroup___bEwyRE",
  "U1": "VoiceActivityCard.module__headerRow___bEwyRE",
  "LD": "VoiceActivityCard.module__headerLeft___bEwyRE",
  "mB": "VoiceActivityCard.module__activityLabel___bEwyRE",
  "l1": "VoiceActivityCard.module__streamingLabel___bEwyRE",
  "kf": "VoiceActivityCard.module__contextButton___bEwyRE",
  "kx": "VoiceActivityCard.module__contextChannelName___bEwyRE",
  "fd": "VoiceActivityCard.module__contextIcon___bEwyRE",
  "gE": "VoiceActivityCard.module__actionIcon___bEwyRE",
  "o_": "VoiceActivityCard.module__contextGuildIcon___bEwyRE",
  "pz": "VoiceActivityCard.module__contextChevron___bEwyRE",
  "mr": "VoiceActivityCard.module__contextDmAvatar___bEwyRE",
  "Nu": "VoiceActivityCard.module__participantsRow___bEwyRE",
  "i1": "VoiceActivityCard.module__previewContainer___bEwyRE",
  "n": "VoiceActivityCard.module__previewSubmitting___bEwyRE",
  "FC": "VoiceActivityCard.module__previewHoverOverlay___bEwyRE",
  "oz": "VoiceActivityCard.module__previewImage___bEwyRE",
  "nZ": "VoiceActivityCard.module__previewFallback___bEwyRE",
  "Mp": "VoiceActivityCard.module__previewHoverText___bEwyRE",
  "$l": "VoiceActivityCard.module__actionRow___bEwyRE",
  "hP": "VoiceActivityCard.module__actionButton___bEwyRE",
};

module.exports = exports;
